export default __webpack_public_path__ + "static/vector-section5-object-8be8118d0cc6746446caa4bfea0c8785.webp";